/*
 * @fileOverView Radio Buttons component definition
 */

import Vue from 'vue';

Vue.component('complex-radio-vue', {
  props: {
    externalValue: {
      type: String,
      default: ''
    }
  },

  data: function () {
    return {
      activeButton: ''
    }
  },

  watch: {
    activeButton: function (val) {
      //don't emit a change from external, to avoid infinite loop
      if (this.internalChange) {
        this.$emit('changed', val);
      }

      this.internalChange = true;
    },

    externalValue: function (val) {
      if (val !== this.activeButton) {
        this.internalChange = false;
        this.activeButton = val;
      }
    }
  },

  mounted() {
    this.activeButton = this.externalValue;
    this.internalChange = true;
  }
});
